import { gql } from "@grandvisionhq/graphql";
const productPriceFragment = gql`
  fragment productPriceFragment on ProductPrice {
    value {
      currencyCode
      centAmount
    }
    discounted {
      value {
        centAmount
        currencyCode
      }
    }
  }
`;
export {
  productPriceFragment
};
//# sourceMappingURL=productPrice.js.map
